<template>
  <div class="main-container test-report">
    <div class="bread">
      <router-link :to="{ name: 'MemberTest' }">我的考试</router-link>
      <span class="slash">/</span>
      <span class="current">{{ testInfo.name }}</span>
    </div>
    <div class="main-content">
      <div class="test-info-content">
        <div class="test-title" :title="testInfo.name">
          {{ testInfo.name }}
        </div>
        <div class="subjective">
          <template v-if="testInfo.subjective">
            <img src="../../images/member/introduce.png" />
            <span>{{ testInfo.subjective }}</span>
          </template>
        </div>
        <div class="paper-detail">
          <div style="margin-right: 48px">
            <label>交卷时间：</label>
            <span>{{ testInfo.submit_time }}</span>
          </div>
          <div style="margin-right: 40px">
            <label>作答时长：</label>
            <span>{{ testInfo.answer_time }}</span>
          </div>
          <div class="record-link" @click="showRecord" v-if="recordList && recordList.length > 1">
            考试记录 >
          </div>
        </div>
        <template
          v-if="
            getTestConfig.show_answer_rule == 1 &&
            (testInfo.test_status == 1 || testInfo.test_status == 3)
          "
        >
          <div class="grade">
            <div style="text-align: center">
              {{ testInfo.score }}
            </div>
            <img src="../../images/member/Vector@2x.png" />
          </div>
          <div class="status-icon">
            <img src="../../images/member/test-status.png" v-if="testInfo.is_pass == 1" />
            <img src="../../images/member/no-pass.png" v-else />
          </div>
        </template>
        <div class="status-icon" v-if="testInfo.test_status == 2">
          <img src="../../images/member/no-approve.png" />
        </div>
      </div>
      <div class="test-result-content">
        <div class="result" v-if="getTestConfig.show_answer_rule == 1">
          <div class="result-left">
            <div class="result-left-info" v-for="item in testInfo.result" :key="item.id">
              <label>{{ item.label }}：</label>
              <span class="result-grade">{{ item.value }}{{ item.unit }}</span>
            </div>
          </div>
          <div class="result-right">
            <div
              class="result-status"
              v-for="(item, index) in testInfo.resultStatus"
              :key="item.id"
            >
              <div class="status-info">
                <div class="value" :class="`status-${item.type}`">
                  {{ item.value }}
                </div>
                <div class="label">
                  {{ item.label }}
                </div>
              </div>
              <div class="divider" v-if="index != testInfo.resultStatus.length - 1"></div>
            </div>
          </div>
        </div>
        <div class="footer-button">
          <div
            v-if="getTestConfig.show_answer_rule == 2"
            class="footer-button-default"
            @click="back"
          >
            返回
          </div>
          <div
            v-if="getTestConfig.show_answer_rule == 1"
            class="footer-button-primary"
            @click="seeDetail"
          >
            查看试卷
          </div>
          <div class="footer-button-default" v-if="getReTest()" @click="inToTest">重新考试</div>
        </div>
      </div>
    </div>
    <TestRecordModal :showModal.sync="showModal" :recordList="recordList" @seeReport="seeReport" />
    <TestCheckModal ref="checkModal" />
  </div>
</template>

<script>
import TestRecordModal from './components/TestRecordModal';

import TestCheckModal from '../member/components/TestCheckModal';
export default {
  name: 'TestReport',
  components: {
    TestRecordModal,
    TestCheckModal,
  },
  data() {
    return {
      showModal: false,
      id: this.$route.params.id,
      getTestConfig: { show_answer_rule: '' },
      recordList: [], //考试报告列表
      testInfo: {
        //试卷详情
        result: [
          {
            id: 'test_score',
            label: '总分',
            value: '',
            unit: '分',
          },
          {
            id: 'pass_score',
            label: '通过分数',
            value: '',
            unit: '分',
          },
          {
            id: 'user_score',
            label: '客观题得分',
            value: '',
            unit: '分',
          },
          {
            id: 'subjective_score',
            label: '主观题总分',
            value: '',
            unit: '分',
          },
        ],
        resultStatus: [
          {
            id: 'right_count',
            type: 1,
            label: '答对',
            value: '',
          },
          {
            id: 'wrong_count',
            type: 2,
            label: '答错',
            value: '',
          },
          {
            id: 'not_answer_count',
            type: 3,
            label: '未作答',
            value: '',
          },
          {
            id: 'short_answer_count',
            type: 4,
            label: '主观题',
            value: '',
          },
        ],
      },
    };
  },
  watch: {
    async $route() {
      await this.$nextTick();
      const id = this.$route.params.id;
      this.id = id;
      await this.getTestReport(id);
    },
  },
  async created() {
    await this.getTestReport(this.id);
  },
  methods: {
    //获取考试报告详情
    async getTestReport(report_id) {
      const res = await this.$http.get('/api/app/testDetail/getTestReport', {
        report_id: report_id,
      });
      const getTestConfig = await this.$http.get('/api/app/getTestConfig/' + res.test_id);
      this.getTestConfig = getTestConfig;
      let subjective = '';
      //当含有主观题 并且人工批阅开启 并且未审批时
      if (res.short_answer_count && res.test_status == 2 && res.audit == 1) {
        subjective = '考试含有主观题，该部分需等待老师批阅';
      } else if (res.test_status == 1 && res.short_answer_count && res.audit == 2) {
        //当含有主观题，并且关闭批阅 并且已经批阅完成
        subjective = '本次考试中，主观题不进行批阅';
      }
      res.answer_time = this.$actionTool.timeMeter(res.answer_time, 3);
      res.submit_time = this.$actionTool.ts(res.submit_time, 'yearminute');
      this.testInfo.result.forEach((i) => {
        if (res.test_status == 2 && i.id == 'subjective_score' && res.audit == 1) {
          i.value = '-';
          i.unit = '';
          i.label = '主观题得分';
        } else if (res.test_status == 1 && i.id == 'subjective_score') {
          if (res.audit == 1) {
            i.label = '主观题得分';
            i.value = res[i.id];
          } else {
            i.label = '主观题总分';
            i.value = res.subjective_total_score;
          }
        } else {
          i.value = res[i.id];
        }
      });
      this.testInfo.resultStatus.forEach((i) => {
        i.value = res[i.id];
      });
      this.testInfo = { ...this.testInfo, ...res, subjective };
      this.getRecordList(res.test_id);
    },
    //获取报告列表
    async getRecordList(test_id) {
      const res = await this.$http.get('/api/app/testDetail/getTestReportRecord', {
        test_id: test_id,
      });
      this.recordList = res || [];
      this.recordList.forEach((i) => {
        i.date = this.$actionTool.ts(i.submit_time, 'yearminute');
        i.dateLength = this.$actionTool.timeMeter(i.answer_time, 3);
      });
    },
    //判断是否可以重新考试
    getReTest() {
      //已批阅  并且答卷次数不做限制，或者答卷次数大于用户交卷次数。没有过期，就可以再次考试
      if (
        this.testInfo.test_status != 2 &&
        (this.testInfo.times == 0 || this.testInfo.times > this.testInfo.user_answer_count) &&
        this.testInfo.has_expired == 0
      ) {
        return true;
      }
      return false;
    },
    //考试记录列表modal
    showRecord() {
      this.showModal = true;
    },
    seeDetail() {
      this.$router.push({
        name: 'TestAnalysis',
        params: { id: this.id },
      });
    },
    back() {
      this.$router.push({
        name: 'MemberTest',
      });
    },
    async inToTest() {
      await this.$refs.checkModal.init(this.testInfo.test_id);
      //先校验
      this.$router.push({
        name: 'TestDetail',
        query: { id: this.testInfo.test_id },
      });
    },
    //点击考试报告列表
    seeReport(id) {
      this.$router.replace({
        name: 'TestReport',
        params: {
          id: id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.test-report {
  margin-bottom: 40px;
  .main-content {
    //background: rgba(255, 255, 255, 1);
    //border-radius: 5px;
    padding: 24px 24px 56px 24px;
    margin-bottom: 30px;
    .test-info-content {
      position: relative;
      background: rgba(255, 255, 255, 1);
      border-radius: 5px;
      margin-bottom: 16px;
      padding: 32px 38px 25px 41px;
      .test-title {
        font-size: 22px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: #333333;
        line-height: 26px;
        max-width: 920px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 10px;
      }
      .subjective {
        height: 24px;
        margin-bottom: 30px;
        img {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 8px;
        }
        span {
          vertical-align: middle;
          line-height: 24px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #999999;
        }
      }
      .paper-detail {
        display: flex;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        height: 28px;
        color: #666666;
        line-height: 28px;
        .record-link {
          cursor: pointer;
        }
      }
      .grade {
        font-size: 42px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: #ff2424;
        line-height: 30px;
        position: absolute;
        top: 32px;
        right: 61px;
        img {
          width: 61px;
          height: 24px;
        }
      }
      .status-icon {
        position: absolute;
        top: 115px;
        right: 38px;
        img {
          width: 92px;
          height: 32px;
        }
      }
    }
    .test-result-content {
      padding: 32px 40px 44px 40px;
      background: #ffffff;
      border-radius: 8px;
      .result {
        display: flex;
        justify-content: space-between;
        .result-left {
          flex-wrap: wrap;
          width: 360px;
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          label {
            display: inline-block;
            color: #999;
            //line-height: 28px;
            height: 30px;
            line-height: 30px;
          }
          .result-grade {
            display: inline-block;
            color: #666666;
            height: 30px;
            line-height: 30px;
          }
          .result-left-info {
            width: 180px;
            margin-bottom: 10px;
            &:last-child {
              margin: 0;
            }
          }
        }
        .result-right {
          display: flex;
          .result-status {
            display: flex;
            .status-info {
              //margin-right: 50px;
              font-size: 32px;
              font-family: PingFang SC, PingFang SC-Semibold;
              font-weight: 600;
              text-align: center;
              line-height: 40px;
              height: 40px;
              vertical-align: middle;
              .status-1 {
                color: #1dcc66;
              }
              .status-2 {
                color: #ff2424;
              }
              .status-3 {
                color: #ffc109;
              }
              .status-4 {
                color: #000;
              }
              .label {
                height: 24px;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: #333333;
                line-height: 24px;
                vertical-align: middle;
              }
            }
            .divider {
              width: 1px;
              height: 44px;
              opacity: 0.1;
              border-right: 1px solid #000000;
              margin: 0 50px;
              vertical-align: middle;
              position: relative;
              top: 10px;
            }
          }
        }
      }
      .footer-button {
        margin-top: 25px;
        display: flex;
        .footer-button-primary {
          width: 120px;
          height: 42px;
          background: $primary-color;
          border-radius: 22px;
          cursor: pointer;

          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: center;
          color: #fff;
          line-height: 42px;
          margin-right: 12px;
        }
        .footer-button-default {
          width: 120px;
          height: 40px;
          border: 1px solid #fc5623;
          border-radius: 22px;
          cursor: pointer;
          margin-right: 12px;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: center;
          line-height: 40px;
          color: #fc5623;
        }
      }
    }
  }
  .course-cert-view {
    ::v-deep {
      .el-dialog {
        width: auto;
        text-align: center;
        background: transparent;
        box-shadow: none;
      }
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
    .course-cert-view_img {
      max-width: 800px;
      max-height: 720px;
    }
    .course-cert-view_close {
      position: absolute;
      width: 32px;
      margin-left: 12px;
      margin-top: -44px;
      cursor: pointer;
    }
  }
}
</style>
